// src/components/_shared/format.js

export function abbr(k = '') {
  if (!k) return '??'
  const t = (String(k).match(/[A-Za-z0-9]/g) || []).join('').toUpperCase()
  return t.length >= 2 ? t.slice(0, 2) : (t || '??')
}

export function shortKey(k = '') {
  const s = String(k || '').trim()
  if (!s) return ''
  if (s.length <= 9) return s
  return `${s.slice(0, 4)}…${s.slice(-4)}`
}

export function shortHash(hash = '') {
  return shortKey(hash)
}

export function formatAmountHuman(raw) {
  const n = Number(raw || 0)
  if (!Number.isFinite(n) || n === 0) return '0'

  const abs = Math.abs(n)
  const sign = n < 0 ? '–' : ''

  if (abs >= 1_000_000_000_000) return sign + (abs / 1_000_000_000_000).toFixed(2).replace(/\.00$/, '') + 'T'
  if (abs >= 1_000_000_000)     return sign + (abs / 1_000_000_000).toFixed(2).replace(/\.00$/, '') + 'B'
  if (abs >= 1_000_000)         return sign + (abs / 1_000_000).toFixed(2).replace(/\.00$/, '') + 'M'
  if (abs >= 1_000)             return sign + (abs / 1_000).toFixed(2).replace(/\.00$/, '') + 'K'
  return sign + abs.toString()
}

// Важно: возвращает строку БЕЗ "SOL"
export function formatSol(lamports) {
  const n = Number(lamports || 0)
  if (!Number.isFinite(n) || n <= 0) return '0'

  const sol = n / 1_000_000_000
  if (sol >= 1_000_000_000) return (sol / 1_000_000_000).toFixed(2).replace(/\.00$/, '') + 'B'
  if (sol >= 1_000_000)     return (sol / 1_000_000).toFixed(2).replace(/\.00$/, '') + 'M'
  if (sol >= 1_000)         return (sol / 1_000).toFixed(2).replace(/\.00$/, '') + 'K'
  const digits = sol >= 1 ? 3 : (sol >= 0.01 ? 4 : 6)
  return sol.toFixed(digits).replace(/0+$/, '').replace(/\.$/, '')
}

export function formatTokenPriceSol(value) {
  const n = Number(value || 0)
  if (!Number.isFinite(n) || n <= 0) return '0'

  if (n >= 1) return trimFixed(n, 4)
  if (n >= 0.01) return trimFixed(n, 6)
  if (n >= 0.000001) return trimFixed(n, 9)
  return trimFixed(n, 18)
}

// Для трейдов: "0.123 ◎"
export function formatLamports(lamports) {
  const n = Number(lamports || 0)
  if (!Number.isFinite(n) || n === 0) return '0 ◎'

  const sol = n / 1_000_000_000
  const digits = Math.abs(sol) >= 1 ? 3 : 5
  let s = sol.toFixed(digits).replace(/0+$/, '').replace(/\.$/, '')
  return `${s} ◎`
}

// Для PnL: "+1.23K" / "-0.55"
export function formatMoney(v) {
  const n = Number(v || 0)
  if (!Number.isFinite(n) || n === 0) return '0'

  const sign = n > 0 ? '+' : '-'
  const abs = Math.abs(n)

  let body
  if (abs >= 1_000_000_000) body = (abs / 1_000_000_000).toFixed(2) + 'B'
  else if (abs >= 1_000_000) body = (abs / 1_000_000).toFixed(2) + 'M'
  else if (abs >= 1_000) body = (abs / 1_000).toFixed(2) + 'K'
  else body = abs.toFixed(2)

  return sign + body.replace(/\.00$/, '')
}

export function formatPct(value) {
  const n = Number(value || 0)
  if (!Number.isFinite(n) || n === 0) return '0%'
  const abs = Math.abs(n)
  const sign = n > 0 ? '+' : '–'
  const digits = abs >= 100 ? 0 : (abs >= 10 ? 1 : 2)
  return `${sign}${(digits ? abs.toFixed(digits).replace(/0+$/, '').replace(/\.$/, '') : abs.toFixed(0))}%`
}

export function formatPnlWithPct(lamports, basisLamports) {
  const n = Number(lamports || 0)
  const basis = Math.abs(Number(basisLamports || 0))
  const sign = n > 0 ? '+' : n < 0 ? '-' : ''
  const value = `${sign}${formatSol(Math.abs(n))}`
  if (!Number.isFinite(basis) || basis <= 0 || !Number.isFinite(n)) return value
  return `${value} (${formatPct(n * 100 / basis)})`
}

function trimFixed(value, digits) {
  return value.toFixed(digits).replace(/0+$/, '').replace(/\.$/, '')
}
